
// const AppHeader = ({ loggedInUser, onLogout}) => (
//   <AntHeader className="app-header">
//     <Space>
//       <Link href="/">
//         <Text strong>My Blog</Text>
//       </Link>
//     </Space>
//     <Space>
//       {loggedInUser ? (
//         <>
//           <Link href="/profile">
//             <Text strong>{loggedInUser.username}</Text>
//           </Link>
//           <Button type="primary" onClick={onLogout}></Button>
//         </>
//       ):}
//     </Space>
//   </AntHeader>
// )
// src/components/Header/index.js
import React from 'react';
import { Layout, Menu, Button, Avatar, Dropdown } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeOutlined,
  FileTextOutlined,
  EditOutlined,
  UserOutlined,
  LoginOutlined,
  LogoutOutlined,
  DownOutlined
} from '@ant-design/icons';

const { Header } = Layout;

const AppHeader = ({ isLoggedIn, onLogout }) => {
  const location = useLocation();
  
  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: <Link to="/">首页</Link>,
    },
    {
      key: '/archive',
      icon: <FileTextOutlined />,
      label: <Link to="/archive">归档</Link>,
    },
    {
      key: '/write',
      icon: <EditOutlined />,
      label: <Link to="/write">写文章</Link>,
      disabled: !isLoggedIn,
    },
    {
      key: '/about',
      icon: <UserOutlined />,
      label: <Link to="/about">个人主页</Link>,
    },
  ];

  const userMenuItems = [
    {
      key: 'about',
      icon: <UserOutlined />,
      label: <Link to="/about">个人主页</Link>,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: onLogout,
    },
  ];

  return (
    <Header className="site-header">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <h1 style={{ margin: 0, marginRight: 40, color: '#1890ff' }}>
            <Link to="/" style={{ color: 'inherit' }}>My Blog</Link>
          </h1>
          <Menu
            theme="light"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{ border: 'none' }}
          />
        </div>
        
        <div>
          {isLoggedIn ? (
            <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
              <Button type="text" style={{ padding: '4px 8px' }}>
                <Avatar icon={<UserOutlined />} style={{ marginRight: 8 }} />
                pigStar
                <DownOutlined style={{ marginLeft: 4 }} />
              </Button>
            </Dropdown>
          ) : (
            <Link to="/auth">
              <Button type="primary" icon={<LoginOutlined />}>
                登录/注册
              </Button>
            </Link>
          )}
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;